<template>
  <public-layout class="page-resource page-service">
    <section class="section is-left-aligned">
      <div class="container">
        <Loader v-if="loading"></Loader>
        <div class="columns" v-else>
          <div class="column is-4">
            <figure class="image">
              <img :src="service.picture">
            </figure>
          </div>
          <div class="column is-7 is-offset-1">
            <h2 class="resource-title">{{ service.title }}</h2>
            <!-- <p class="resource-meta">
              <span class="resource-subject tag" :class="`is-category-${subject.id}`" v-for="subject in service.subjects" :key="subject.id" :style="getTagColor(subject)">{{ subject.name }}</span>
              <span class="resource-category">{{ service.type.name }}</span>
            </p> -->
            <p class="resource-description">{{ service.description }}</p>
            <div class="resource-meta service-meta">
              <div class="columns is-multiline">
                <div class="column is-5">
                  <p class="" v-html="service.tlblock"></p>
                </div>
                <div class="column is-5">
                  <p class="resource-meta-text" v-html="service.trblock"></p>
                </div>
                <div class="column is-5">
                  <p class="resource-meta-text" v-html="service.blblock"></p>
                </div>
                <div class="column is-5">
                  <p class="resource-meta-text" v-html="service.brblock"></p>
                </div>
              </div>
              <div class="columns">
                <!-- <div v-if="service.goals !== ''" class="column is-5">
                  <h4 class="resource-meta-title">Things I learned</h4>
                  <p class="resource-meta-text">{{ service.goals }}</p>
                </div> -->
              </div>
            </div>
            <router-link v-if="service.register" class="button button-large button-primary" :to="{ name: 'register' , params: { jotform: service.register } }">Register Now</router-link>
            <router-link v-if="service.contact" class="button button-large button-primary" :to="{ name: 'register' , params: { jotform: service.contact } }">Contact Us</router-link>
            <a class="button button-large button-secondary" @click="$router.go(-1)">Go Back</a>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-centered">
      <div class="columns is-mobile is-centered">
        <div class="column">
          <h2 class="section-title has-text-centered">
            <strong>{{ service.bottomText }}</strong>
          </h2>
          <a v-if="service.bimage && service.brochure" class="brochure-container" :href="service.brochure" target="_blank">
            <img :src="service.bimage"/>
            <span class="button button-large button-primary">Download</span>
          </a>
          <img v-else-if="service.bimage" class="image" :src="service.bimage"/>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import Loader from '@/components/Loader'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    PublicLayout,
    Loader
  },

  watch: {
    '$route.params.id': 'fetch'
  },

  computed: {
    ...mapState('service', {
      service: state => state.service,
      loading: state => state.isFetching
    })
  },

  methods: {
    ...mapActions('service', {
      getService: 'get'
    }),

    fetch (serviceId) {
      this.getService(serviceId)
    }

  },

  created () {
    this.fetch(this.$route.params.id)
  },

  data () {
    return {}
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.page-resource .main {

  .section:nth-child(2) {
    padding-top: 0;
  }
}

.page-service{
  ul{
    list-style: disc;
  }
  li{
    margin-left: 2rem;
  }
}

.resource-title {
  margin-bottom: 1rem;
  @include text-size-xl();
  font-weight: 600;
  color: $color-text-dark;

  @media screen and (min-width: 768px) {
    @include text-size-xxxl();
  }
}

.resource-category {
  margin-left: 1rem;
  margin-bottom: .5rem;
  text-transform: uppercase;
  @include text-size-xs();
  font-weight: 600;
}

.resource-description {
  margin-bottom: 1.5rem;
}

.resource-meta {
  margin-bottom: 1.5rem;

  @media screen and (min-width: 768px) {
    margin-bottom: 2rem;
  }
}

.resource-meta-title {
  margin-bottom: .5rem;
  color: $color-text-dark;
}

.brochure-container{
    position: relative;
    display: inline-block;
    img {
      display: block;
    }
    span{
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 2rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/ServicePage.vue